import { render, staticRenderFns } from "./MyMemories.vue?vue&type=template&id=09943940&scoped=true&"
import script from "./MyMemories.vue?vue&type=script&lang=js&"
export * from "./MyMemories.vue?vue&type=script&lang=js&"
import style0 from "./MyMemories.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MyMemories.vue?vue&type=style&index=1&id=09943940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09943940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VImg,VPagination,VRow,VSkeletonLoader})
